import { render, staticRenderFns } from "./ReportSalesPerCustomerPage.vue?vue&type=template&id=2bf9d89f&scoped=true"
import script from "./ReportSalesPerCustomerPage.vue?vue&type=script&lang=js"
export * from "./ReportSalesPerCustomerPage.vue?vue&type=script&lang=js"
import style0 from "./ReportSalesPerCustomerPage.vue?vue&type=style&index=0&id=2bf9d89f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf9d89f",
  null
  
)

export default component.exports